export const MAX_FILE_SIZE_IN_BYTES = 10 * 1_048_576; // 10 megabytes

export const MAX_FILE_SIZE_AS_MEGABYTES_STRING = '10MB';
